/*
 * @Author: 小周
 * @Date: 2023-10-13 15:59:45
 * @LastEditTime: 2024-08-01 15:55:29
 * @LastEditors: MrZHLF
 * @Description:
 */
import request from '@utils/request'

let BASE_URL = process.env.REACT_APP_API_COMMENT
let OLYMPIAD = process.env.REACT_APP_OLYMPIAD

export const getList = (params) => {
  return request({
    url: BASE_URL + '/mobile/cms/articles',
    method: 'get',
    params,
  })
}

export const getDetail = (id) => {
  return request({
    url: BASE_URL + `/mobile/cms/articlewithrelated?articleId=${id}`,
    method: 'get',
  })
}

export const getMedalList = () => {
  return request({
    url: OLYMPIAD + '/getMedalRanking/rank/by/gold',
    method: 'get',
  })
}
